import p from "../../node_modules/.pnpm/tippy.js@6.3.7/node_modules/tippy.js/dist/tippy.esm.mjs";
import "../../tippy.css.mjs";
const i = (o, t) => {
  o.$_tuiTooltip ? o.$_tuiTooltip.setContent(t.value) : o.$_tuiTooltip = p(o, {
    content: String(t.value)
  });
}, l = (o) => {
  o.$_tuiTooltip && (o.$_tuiTooltip.destroy(), delete o.$_tuiTooltip);
}, T = {
  beforeMount: i,
  updated: i,
  beforeUnmount: l
};
export {
  T as default
};
//# sourceMappingURL=directive.mjs.map
